import React, { FC } from 'react';
import {
  DeliveryDestination,
  RentalStation,
} from '../@types/codegen/graphql';
import { AddressInformation } from '../hooks/use-address-information';

interface IReadableAddressProps {
  address:
    Pick<RentalStation, 'street' | 'streetNumber' | 'zip' | 'city' | 'country'>
  | Pick<DeliveryDestination, 'street' | 'streetNumber' | 'zip' | 'city' | 'country'>
}

export const readableAddress = (address: IReadableAddressProps['address']): string => {
  if (!address) {
    return '';
  }

  // @todo: Fix in API
  // @ts-ignore
  const city = readableAddressWithoutCountry(address);
  const country = 'string' === typeof address.country ? `, ${address.country}` : '';

  return `${city} ${country}`;
};

export const readableAddressWithCountryObject = (address: Pick<RentalStation, 'street' | 'streetNumber' | 'zip' | 'city' | 'country'>): string => {
  const city = readableAddressWithoutCountry(address);
  const country = address.country.name;

  return `${city} ${country}`;
};

export const readableAddressWithoutCountry = (address: Pick<RentalStation, 'street' | 'streetNumber' | 'zip' | 'city'>): string => {
  return `${address.street ?? ''} ${address.streetNumber ?? ''}, ${address.zip} - ${address.city}`;
};

export const readableAddressShort = (address: AddressInformation): string => {
  if (!address) {
    return '';
  }

  return `${address.street ?? ''} ${address.streetNumber ?? ''}, ${address.city}`;
};


export const ReadableMultilineAddress: FC<IReadableAddressProps> = ({ address }) => {
  if (!address) {
    return null;
  }
  const country = 'string' !== typeof address.country ? address.country?.name : '';

  return (
    <>
      {address.street ?? ''} {address.streetNumber ?? ''}<br />
      {address.zip} {address.city}<br />
      {country}<br />
    </>
  );
};
